mutation FinishVideoFileUpload($id: ID!) {
  finishVideoFileUpload(id: $id) {
    id
    status
    error
  }
}
